import { FilterDefinitionForExtras } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { FilterSetDefinitionWithValues } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { FilterStoreValue } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';

export const convertFilterDefinitionForExtrasToFilterStoreValue = ({
  filterSetDefinitions,
  filterDefinitionForExtras,
}: {
  filterSetDefinitions: FilterSetDefinitionWithValues['filterDefinitions'];
  filterDefinitionForExtras: FilterDefinitionForExtras;
}): FilterStoreValue | null => {
  const definition = filterSetDefinitions.find(
    (definition) =>
      definition.columnHeaderValue ===
      filterDefinitionForExtras.columnHeaderValue,
  );

  if (!definition) {
    return null;
  }

  if (!definition.displayType || definition.displayType === 'select_multi') {
    // string[]
    return filterDefinitionForExtras.values;
  }

  if (definition.displayType === 'select_single') {
    // string
    return filterDefinitionForExtras.values[0];
  }

  if (definition.displayType === 'range_scalar') {
    // converting this to [number, number] by finding the min and max

    if (filterDefinitionForExtras.values.length === 0) {
      return null;
    }

    // find the smallest and the largest years from the values
    const minValue = Math.min(
      ...filterDefinitionForExtras.values.map((v) => parseInt(v, 10)),
    );
    const maxValue = Math.max(
      ...filterDefinitionForExtras.values.map((v) => parseInt(v, 10)),
    );

    return [minValue, maxValue];
  }

  return null;
};
